var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _thumborUrlBuilder = _interopRequireDefault(require("thumbor-url-builder"));

var ImageResizer = function ImageResizer() {
  (0, _classCallCheck2.default)(this, ImageResizer);
  return new _thumborUrlBuilder.default('', 'https://reshape.sport1.de');
};

var _default = ImageResizer;
exports.default = _default;